let filterContainer;
let templateRequest;
let deferredTemplateRequest;
const overlayClass = 'page-appstore--overlay';

function facetsBusy( busy ) {
	if( !filterContainer ) { return; }
	filterContainer.setAttribute( 'aria-busy', busy ? 'true' : 'false' );

	const loader = filterContainer.querySelector( '.loading' );
	const loaderClass = 'loading--active';
	if( busy ) {
		loader.classList.add( loaderClass );
	} else {
		loader.classList.remove( loaderClass );
	}
}

function facetChanged() {
	if( templateRequest ) {
		templateRequest( this.value );
	}
}

function setupTemplateRequest( getData ) {
	templateRequest = getData;

	if( deferredTemplateRequest ) {
		templateRequest( deferredTemplateRequest );
		deferredTemplateRequest = null;
	}
}

function toggleAccordion( e ) {
	if( e ) { e.preventDefault(); }

	const isExpanded = this.getAttribute( 'aria-expanded' ) === 'true';
	const panelEle = document.getElementById( this.getAttribute( 'href' ).substring( 1 ) );
	const panelClass = 'facet-filter__terms--expanded';
	const parentWrap = this.closest( '.facet-filter__accordion' );
	const wrapClass = 'facet-filter__accordion--open';
	
	this.setAttribute( 'aria-expanded', isExpanded ? 'false' : 'true' );
	if( panelEle && parentWrap ) {
		if( isExpanded ) {
			panelEle.classList.remove( panelClass );
			parentWrap.classList.remove( wrapClass );
		} else {
			panelEle.classList.add( panelClass );
			parentWrap.classList.add( wrapClass );
		}
	}
}

function escapeRegex( value ) {
	// https://stackoverflow.com/a/25837411/738394
	return value.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&' ); // eslint-disable-line no-useless-escape
}

function cleanEndpoint( url, removeOffset, removeFilters, encoded, addParams ) {		
	let workingUrl = url;
	if( removeOffset ) {
		let offset = 'page[offset]';
		if( encoded ) { offset = encodeURIComponent( offset ); }
		else { offset = escapeRegex( offset ); }
		const offsetRegEx = new RegExp( `&?${offset}=\\d*` );
		workingUrl = workingUrl.replace( offsetRegEx, '' );
	}

	if( removeFilters ) {
		let filter1 = 'filter[';
		let filter2 = ']';
	
		if( encoded ) {
			filter1 = encodeURIComponent( filter1 );
			filter2 = encodeURIComponent( filter2 );
		} else {
			filter1 = escapeRegex( filter1 );
			filter2 = escapeRegex( filter2 );
		}

		const filterRegEx = new RegExp( `&?${filter1}[^\\[]*${filter2}=[^&]*`, 'g' );
		workingUrl = workingUrl.replaceAll( filterRegEx, '' );
	}

	workingUrl = workingUrl.replace( /\?$/, '' ); // remove trailing question mark
	workingUrl = workingUrl.replace( /&$/, '' ); // remove trailing ampersand mark
	workingUrl = workingUrl.replaceAll( /\?&/g, '?' ); // remove any doubled up ?&
	workingUrl = workingUrl.replaceAll( /&&/g, '&' ); // remove any doubled up &&

	if( addParams ) {
		if( workingUrl.indexOf( '?' ) >= 0 ) { workingUrl += '&'; }
		else { workingUrl += '?'; }

		workingUrl += addParams;
	}
	
	workingUrl = applySortByTitleQuery(workingUrl);

	return workingUrl;
}

function normalizeId( facetId, term ) {
	return `${facetId}_${term.values.value.toLowerCase().match(/[a-z0-9\s]/g).join('').replace(/\s/g, '-')}`;
}

function renderCheckbox( facetId, term, endpoint = cleanEndpoint( term.url, true, false, true, false ) ) {
	const id = normalizeId( facetId, term );

	return `
		<input class="sr-only" type="checkbox" name="filter[${facetId}]" value="${endpoint}" id="${id}"${term.values.active ? ' checked' : ''}/>
		<label for="${id}">${term.values.label}&nbsp;(${term.values.count})</label>
	`;
}

function errorState() {
	facetsBusy( false );
	filterContainer.querySelector( '.facet-filter__content' ).innerHTML = '';
}

// escapes specific characters for the filter parameters as needed by removeFilter
function escapeFacetRegex( str ) {
	return str
		.replaceAll( '[', '\\[' )
		.replaceAll( ']', '\\]' )
		.replaceAll( '-', '\\-' )
		.replaceAll( '=', '\\=' );
}

// removes the filter param from a url when it's in combination with others in the same facet
function removeFilter( url, facetPath, value, combinationParams ) {
	let newUrl = url;
	const regStr = ( combinationParams ? `filter[${facetPath}-facet][condition][value][\\d+]=${value}` : `filter[${facetPath}]=${value}` );
	
	const reg = new RegExp( escapeFacetRegex( regStr ), 'gi' );
	newUrl = newUrl.replace( reg, '' ); // remove unescaped filter

	const regEnc = new RegExp( escapeFacetRegex( encodeURI( regStr ).replaceAll( '%5C', '\\' ) ), 'gi' ); // put the slashes back after encoding (they're needed for the regex)
	newUrl = newUrl.replace( regEnc, '' ); // remove escaped filter
	
	newUrl = newUrl.replaceAll( '&&', '&' ); // remove duplicate &	
	newUrl = newUrl.replace( /&$/gi, '' ); // remove trailing &

	// TODO: If I removed [value][0], does [value][1] need to shift down?

	return newUrl;
}

function renderFacets( data ) {
	if( !filterContainer || !data?.meta?.facets ) {
		errorState();
		return;
	}

	const defaultOpenCategories = ['app_audience', 'types_of_apps'];
	let hasOpenCategories = false;
	
	const filteredFacets = cleanFacets(data.meta.facets);

	const categoryOrder = ['app_audience', 'types_of_apps', 'devices', 'managed_by'	];
	const sortedFacets = filteredFacets.sort( ( facetA, facetB ) => (
		categoryOrder.indexOf( facetA.id ) - categoryOrder.indexOf( facetB.id )
	) );

	let htmlStr = '';
	sortedFacets.forEach( facet => {
		let termsHTMLStr = '';
		let hasActiveCheckbox = false;

		facet.terms.forEach( term => {
			if( term.children ) {
				termsHTMLStr += `<h3>${term.values.label}</h3>`;

				term.children[0].forEach( childTerm => {
					let endpointOverride;
					if( childTerm.values.active ) {
						hasActiveCheckbox = true;
						hasOpenCategories = true;

						// Hierarchical filters that are checked don't clear itself from their endpoint properly so that they can be unchecked
						endpointOverride = cleanEndpoint( childTerm.url, true, false, true, false ).split( '?' ); // Pull the endpoint apart for manipulation of the parameters
						endpointOverride[1] = removeFilter( endpointOverride[1], facet.path, childTerm.values.value, true ); // Remove self in combo params
						endpointOverride[1] = removeFilter( endpointOverride[1], facet.path, childTerm.values.value, false ); // Remove self in regular params
						endpointOverride[1] = removeFilter( endpointOverride[1], facet.path, term.values.value, true ); // Remove parent in combo params
						endpointOverride[1] = removeFilter( endpointOverride[1], facet.path, term.values.value, false ); // Remove parent in regular params
						endpointOverride = endpointOverride.join( '?' ); // stick the url base back together with the manipulated parameters
					}
					termsHTMLStr += renderCheckbox( facet.id, childTerm, endpointOverride );
				} );
			} else {
				termsHTMLStr += renderCheckbox( facet.id, term );
				if( term.values.active ) { hasActiveCheckbox = true; hasOpenCategories = true; }
			}
		} );

		htmlStr += `<article class="facet-filter__accordion${hasActiveCheckbox? ' facet-filter__accordion--open' : '' }">
			<h2 class="facet-filter__category"><a href="#${facet.id}" aria-controls="${facet.id}" aria-expanded="${hasActiveCheckbox}"><span>${facet.label}</span></a></h2>
			<div id="${facet.id}" class="facet-filter__terms${hasActiveCheckbox ? ' facet-filter__terms--expanded': ''}">
				<div class="facet-filter__terms-wrap">`;

		htmlStr += termsHTMLStr;

		htmlStr +=`
				</div>
			</div>
		</article>`;
	} );

	filterContainer.querySelector( '.facet-filter__content' ).innerHTML = htmlStr;

	Array.from( filterContainer.querySelectorAll( '[type="checkbox"]' ) ).forEach( ( ele ) => {
		ele.addEventListener( 'change', facetChanged );
	} );

	Array.from( filterContainer.querySelectorAll( '.facet-filter__category a' ) ).forEach( ( ele ) => {
		ele.addEventListener( 'click', toggleAccordion );

		if( !hasOpenCategories && defaultOpenCategories.indexOf( ele.getAttribute( 'aria-controls' ) ) >= 0 ) {
			toggleAccordion.apply( ele );
		}
	} );

	facetsBusy( false );
}

function populateInitialFacets( url ) {
	facetsBusy( true );

	fetch( url )
		.then( response => {
			if( !response.ok ) {
				throw new Error( response.statusText );
			}
			return response.json();
		} )
		.then( data => {
			renderFacets( data );
		} )
		.catch( error => {
			console.error( 'Unable to fetch initial facets', error );
			renderFacets( {} );
		} );
}

function getInitialRequestEndpoint() {
	const { initialEndpoint } = filterContainer.dataset;
	if( !initialEndpoint ) { return [false, false]; }

	let modifyEndpoint = false;
	const queryString = window.location.search;
	if( queryString && queryString.length ) {
		modifyEndpoint = ( queryString.indexOf( '?filter' ) >= 0 || queryString.indexOf( '&filter' ) >= 0 );
	}

	// No alterations, just request the original endpoint
	if( !modifyEndpoint ) { return [initialEndpoint, false]; }

	// Otherwise, alter the initial endpoint based on what is in the URL
	let paramObj = {};

	// Pull all the parameters out of the initial base request
	let initialQueryParams = initialEndpoint.split( '?' );
	initialQueryParams = ( initialQueryParams.length ? initialQueryParams[1] : '' ).split( '&' );
	initialQueryParams.forEach( ( param ) => {
		const split = param.split( '=' );
		paramObj = {...paramObj, [split[0]]: split[1] };
	} );

	// Pull only the parameters on the URL now that are filters
	queryString.substring( 1 ).split( '&' ).forEach( ( param ) => {
		const split = param.split( '=' );

		if( split[0].indexOf( 'filter' ) === 0 ) {
			// combine with the paramObj and override if the key matches
			paramObj = {...paramObj, [split[0]]: split[1] };
		}
	} );

	// Recombine the object into a param string
	let newQueryParams = Object.entries( paramObj ).map( ([ key, value]) => (
		`${key}=${value}`
	) ).join( '&' );

	newQueryParams = applySortByTitleQuery(newQueryParams);

	return [`${initialEndpoint.split( '?' )[0]}?${newQueryParams}`, true];
}

function applySortByTitleQuery(query) {
	//Apply sort x title if search term is not used
	const params = new URLSearchParams(query);
	const paramValue = params.get('filter[fulltext]');

	return (!paramValue) ? query + '&sort=title' : query;
}

function closeOverlay( 
	mainWrapper = document.querySelector( '.page-appstore__wrapper' ),
	mainBody = mainWrapper.querySelector( '.page-appstore__main' )
) {
	mainWrapper.classList.remove( 'page-appstore--overlay' );
	// eslint-disable-next-line no-use-before-define
	mainBody.removeEventListener( 'click', clickedOverlay );
}

function clickedOverlay( e ) {
	if( e.target.isSameNode( this ) ) {
		closeOverlay( undefined, this );
	}
}

function toggleFilterOverlay( e ) {
	e.preventDefault();
	const mainWrapper = document.querySelector( '.page-appstore__wrapper' );
	const isOverlaying = mainWrapper.classList.contains( overlayClass );
	const mainBody = mainWrapper.querySelector( '.page-appstore__main' );

	if( isOverlaying ) {
		closeOverlay( mainWrapper, mainBody );
	} else {
		mainWrapper.classList.add( 'page-appstore--overlay' );
		mainBody.removeEventListener( 'click', clickedOverlay );
		mainBody.addEventListener( 'click', clickedOverlay );
	}

	mainWrapper.classList.toggle( 'page-appstore--desktop-expanded' );
}

function clickedClearAll() {
	templateRequest( document.querySelector( '.facet-filter' ).dataset.initialEndpoint );
}

function addClearAllListener( target ) {
	target.removeEventListener( 'click', clickedClearAll );
	target.addEventListener( 'click', clickedClearAll );
}

function cleanFacets (data) {
	return data.filter(items => !['myapplist'].includes(items.id) )
}

function init() {
	filterContainer = document.querySelector( '.facet-filter' );
	if( !filterContainer ) { return; }

	const filterOverlayBtns = document.querySelectorAll( '.page-appstore__main .btn-filterby, .facet-filter__collapse-btn' );
	Array.from( filterOverlayBtns ).forEach( ( ele ) => {
		ele.addEventListener( 'click', toggleFilterOverlay );
	} );

	addClearAllListener( filterContainer.querySelector( '.facet-filter__clear' ) );

	const [endpoint, isTemplateRequest] = getInitialRequestEndpoint();
	if( endpoint ) {
		if( isTemplateRequest && templateRequest ) {
			templateRequest( endpoint );
		} else if( isTemplateRequest && filterContainer.dataset.template ) {
			// this is a template request, but it's not ready yet; stash it for setupTemplateRequest to pick up once it's called
			deferredTemplateRequest = endpoint;
		} else {
			populateInitialFacets( endpoint );
		}
	}
}

if (
	document.readyState === "complete" ||
	(document.readyState !== "loading" && !document.documentElement.doScroll)
) {
	init();
} else {
	let eventSrcUrl = null;
	document.addEventListener('DOMContentLoaded', ( e ) => {
		if( eventSrcUrl !== e.target.URL ) {
			eventSrcUrl = e.target.URL
			init();
		}
	} );
}

export default {
	setupTemplateRequest, // call this to setup the 2-way communication
	renderFacets, // call this when the page recieves new data
	facetsBusy, // call this when the page initiates a new request
	addClearAllListener, // utility function that adds a listener to a clear all link
	normalizeId, // utility function that returns a normalized id (used on the checkboxes)
	cleanFacets, // utility function that filter out myapplist facets from data
};